import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { MediumPage } from '../../Controls/MediumPage';
import { Input } from '../../Controls/Input';
import { PageTitle } from '../../Controls/PageTitle';
import { Button } from '../../Controls/Button';
import { OperatorApi, ServerRequestsCreateOperatorRequest, ServerRequestsPatchOperatorRequest } from '../../shared/api/axios-client';
import { createApiService } from '../../shared/apiConfig';
import { useParams, useNavigate } from 'react-router-dom';
import ImageUploader from '../../Controls/ImageUploader';
import { toast } from 'react-toastify';
import { fileToBase64 } from '../../helpers/FileUtils';
import { Button as BsButton } from "react-bootstrap";



const EditOperatorPage: React.FC = () => {
    const { operatorId } = useParams<{ operatorId: string }>();
    const [thumbnailFile, setThumbnailFile] = useState<File>();
    const [thumbnailPrev, setThumbnailPrev] = useState<string>();
    const navigate = useNavigate();
    const [editOperator, setEditOperator] = useState<ServerRequestsPatchOperatorRequest | null>(null);
    const { register, reset, handleSubmit, formState: { errors } } = useForm<ServerRequestsPatchOperatorRequest>();
    const operatorAction = operatorId ? "Edit" : "Add"



    useEffect(() => {
        const fetchOperator = async () => {
            const response = await createApiService(OperatorApi).get({
                id: parseInt(operatorId!)
            })

            const operator = response.data.item!
            const editOperator = {
                address: operator.address,
                bottomLeftText: operator.bottomLeftText,
                bottomLeftTitle: operator.bottomLeftTitle,
                bottomRightText: operator.bottomRightText,
                bottomRightTitle: operator.bottomRightTitle,
                emailAddress: operator.emailAddress,
                hostName: operator.hostName,
                logoUrl: operator.logoUrl,
                name: operator.name,
                phoneNumber: operator.phoneNumber,
                topText: operator.topText,
                topTitle: operator.topTitle,
                website: operator.website
            }
            if (operator.logoUrl) {
                setThumbnailPrev(operator.logoUrl)
            }
            reset(editOperator)
            setEditOperator(editOperator);
        };
        if (operatorId)
            fetchOperator();
    }, [operatorId]);

    const updateOperatorFunc = async (operator: ServerRequestsPatchOperatorRequest) => {
        createApiService(OperatorApi).patch({
            id: parseInt(operatorId!),
            serverRequestsPatchOperatorRequest: operator
        }).then((response) => {
            if(response.data.errors){
                const msg = Object.values(response.data.errors).join(' ');
                toast.info(msg)
            } else{
                toast.success('Operation completed sucessfully')
            }
            
        }).catch((error) => {
            toast.error('Operation not complete')
        })

    }
    const addOperatorFunc = async (operator: ServerRequestsCreateOperatorRequest) => {
        createApiService(OperatorApi).create({
            serverRequestsCreateOperatorRequest: operator
        }
        ).then((response) => {
            if(response.data.errors){
                const msg = Object.values(response.data.errors).join(' ');
                toast.info(msg)
            } else{
                toast.success('Operation completed sucessfully')
            }
        }).catch((error) => {
            toast.error('Operation not complete')
        })

    }
    const onSubmit = async (data: any) => {
        const updatedOperator = { ...editOperator, ...data };
        if (thumbnailPrev && thumbnailFile) {
            updatedOperator.logoUrlBase64 = await fileToBase64(thumbnailFile!)
        }
        if (operatorId) {
            await updateOperatorFunc(updatedOperator)
        } else {
            await addOperatorFunc(updatedOperator)
        }

        navigate('/admin/operators');
    };

    return (

        <MediumPage>
            <PageTitle>
                <div className="d-flex align-items-center gap-3">
                    <BsButton variant="link" className="p-0" onClick={() => navigate('/admin/operators')}> ← Back</BsButton>
                    {operatorAction} Operator {editOperator?.name}
                </div>
             </PageTitle>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Input label="Name" type="text" maxLength={64} {...register('name', { required: "Name is required",maxLength:64 })} error={errors.name} />
                <div className="two-col">
                    <Input label="Street" type="text" maxLength={64} {...register('address.addressLine1', { required: "Street is required",maxLength:64 })} error={errors['Address.street']} />
                    <Input label="City" type="text"  maxLength={64}  {...register('address.city', { required: "City is required",maxLength:64 })} error={errors['address.city']} />
                    <Input label="State" type="text"  maxLength={4} {...register('address.state', { required: "State is required",maxLength:4 })} error={errors['address.state']} />
                    <Input label="ZipCode" type="text" maxLength={10}  {...register('address.zipCode', { required: "ZipCode is required",maxLength:10 })} error={errors['address.zipCode']} />
                </div>
                <Input label="Email Address" type="email" maxLength={128} {...register('emailAddress', { required: "Email Address is required" })} error={errors.emailAddress} />
                <Input label="Phone Number" type="text"  maxLength={16} {...register('phoneNumber', { required: "Phone Number is required" })} error={errors.phoneNumber} />
                <Input label="Website" type="text"  maxLength={128}  {...register('website', { required: "Website is required" })} error={errors.website} />
                <Input 
                    label="Hostname" 
                    type="text"  
                    maxLength={24} 
                    readOnly={editOperator != null}  
                    {...register('hostName', { 
                        required: "Hostname is required",
                        maxLength: 24,
                        pattern: {
                            value: /^[a-zA-Z0-9]+$/,
                            message: "Hostname must contain only letters and numbers"
                        },
                        setValueAs: (value: string) => value.toLowerCase()
                    })} 
                    error={errors.hostName} 
                />
                {/* <Input label="Logo URL" type="text" {...register('logoUrl')} error={errors.logoUrl} /> */}
                <ImageUploader
                    setFile={setThumbnailFile}
                    preview={thumbnailPrev}

                    setPreview={setThumbnailPrev}>
                    Add Logo
                </ImageUploader>
                <Input label="Top Title" type="text"  maxLength={128}  {...register('topTitle')} error={errors.topTitle} />
                <Input label="Top Text" type="text" as="textarea"  maxLength={512} {...register('topText')} error={errors.topText} rows={3} />
                <Input label="Bottom Left Title" type="text"  {...register('bottomLeftTitle')} error={errors.bottomLeftTitle} />
                <Input label="Bottom Left Text" type="text" maxLength={512} as="textarea"  {...register('bottomLeftText')} error={errors.bottomLeftText} rows={3} />
                <Input label="Bottom Right Title" type="text" maxLength={512}  {...register('bottomRightTitle')} error={errors.bottomRightTitle} />
                <Input label="Bottom Right Text" type="text" maxLength={512} as="textarea"  {...register('bottomRightText')} error={errors.bottomRightText} rows={3} />
                <div className="d-flex justify-content-end gap-2 mb-3">
                    <Button type="button" className="w-50" onClick={() => navigate('/admin/operators')}>Cancel</Button>
                    <Button type="submit" className="w-50 btn-main">Save Changes</Button>
                </div>
            </form>
        </MediumPage>
    );
};

export default EditOperatorPage;